import algoliaSearch from 'algoliasearch/lite'
import { history } from 'instantsearch.js/es/lib/routers'
import { simple } from 'instantsearch.js/es/lib/stateMappings'

const SearchClient = algoliaSearch(
    productSearchID,
    productSearchKey
)

let initialTitle = null

const SearchRouting = index => ({
    router: history({
        push(url) {
            window.history.replaceState({}, '', url)
        },

        windowTitle(params) {
            if (initialTitle === null) {
                initialTitle = document.title
            }

            let title = initialTitle

            if (params.categoryLvl0) {
                title = params.categoryLvl0.at(-1) + ' | ' + title
            }
            if (params.brand && params.brand[0]) {
                title = params.brand[0] + ' ' + title
            }

            return title
        },

        createURL({ qsModule, routeState, location }) {
            let base = location.pathname
            if (base.startsWith('/brand/')) {
                base = '/products'
            }

            if (routeState.query === '') {
                delete routeState.query
            }
            if (routeState.hitsPerPage === 20) {
                delete routeState.hitsPerPage
            }
            return `${location.origin}${base}` + qsModule.stringify(routeState, { addQueryPrefix: true, arrayFormat: 'repeat' })
        },
        parseURL({ qsModule, location }) {
            const params = qsModule.parse(location.search.slice(1))

            Object.entries(params).forEach(([attr, value]) => {
                if (typeof value === 'string') {
                    params[attr] = [ value ]
                }
            })

            const brand = document.body.querySelector('[data-brand]')?.dataset?.brand
            if (brand) {
                params.brand = [ brand ]
            }

            return params
        },
    }),
    stateMapping: {
        stateToRoute(uiState) {
            const params = Object.assign({}, ...Object.values(Object.values(uiState)?.[0]))
            return params
        },
        routeToState(routeState) {
            const uiState = { configure: {}, hierarchicalMenu: {}, refinementList: {} }

            for (let [prop, value] of Object.entries(routeState)) {
                if (prop === 'query' || prop === 'hitsPerPage') {
                    uiState.configure[prop] = value
                } else if (prop === 'categoryLvl0') {
                    uiState.hierarchicalMenu.categoryLvl0 = value
                } else {
                    uiState.refinementList[prop] = value
                }
            }

            return { [index]: uiState }
        },
    },
})


/**
 * Extracts the user ID from the Google Analytics device ID.
 * @example `GA1.1.xxxxxxxxxx.xxxxxxxxxx => xxxxxxxxxx_xxxxxxxxxx`
 * @link https://support.google.com/analytics/answer/11397207
 */
function extractGoogleAnalyticsUserIdFromCookie(gaCookie) {
  if (gaCookie) {
    // Remove the Google Analytics tracker from the device ID.
    const userIdParts = gaCookie.split('.').slice(-2);
    if (userIdParts.length === 2) {
      return userIdParts.join('_');
    }
  }
  return undefined;
}

function getBrowserCookie(cookieName) {
  // In React Native environments, `document.cookie` doesn't exist.
  if (typeof document !== 'object' || typeof document.cookie !== 'string') {
    return undefined;
  }
  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return undefined;
}

/**
 * Returns the Google Analytics User ID from a browser cookie name.
 * @example `getGoogleAnalyticsUserIdFromBrowserCookie('_ga')`
 */
function getGoogleAnalyticsUserIdFromBrowserCookie(cookieName) {
  const browserCookie = getBrowserCookie(cookieName);

  if (!browserCookie) {
    return undefined;
  }

  return extractGoogleAnalyticsUserIdFromCookie(browserCookie);
}

const initializeAlgolia = () => {
    if (window.aa) {
        const ga_token = getGoogleAnalyticsUserIdFromBrowserCookie('_ga')
        const token = document.querySelector('[data-user-token]').dataset.userToken

        window.aa('setUserToken', ga_token)
        if (token) {
            window.aa('setAuthenticatedUserToken', token)
        }
    }
}

export { SearchClient, SearchRouting, initializeAlgolia }
